
<DocumentList :document-service="EntityDocumentService">
  <template #pageHeader>
    <div>
      <EntityShowHeader :entity="entity" />
      <DocumentResourceNav :resource="'entities'" />
    </div>
  </template>
</DocumentList>
